/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveBackIcon16Regular = forwardRef('TimeClockMoveBackIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.43 2.687A5.503 5.503 0 0 0 3.177 5.35a.751.751 0 0 1-.112.154h1.2a.75.75 0 1 1 0 1.5H1.75a.75.75 0 0 1-.75-.75V2.766a.75.75 0 1 1 1.5 0v.9a7.003 7.003 0 1 1-.788 7.416.75.75 0 1 1 1.347-.66 5.503 5.503 0 1 0 6.37-7.735Z" }),
        React.createElement("path", { d: "M8.5 4.699a.75.75 0 0 0-1.5 0v2.675c0 .67.383 1.282.987 1.574l2.134 1.035a.75.75 0 1 0 .654-1.35L8.641 7.6a.25.25 0 0 1-.141-.225V4.699Z" })));
});
